import { DeliveryShipmentCostsRepository } from '../repositories/delivery-shipment-costs.repository'

import {
    DeliveryIndividualShipmentCostPayload,
    DeliveryIndividualStandardParamsPayload,
    GetDeliveryShipmentCostsParams,
    GetDeliveryShipmentCostsResponse,
    GetDeliveryStandardParamsParams,
    GetDeliveryStandardParamsResponse,
} from '@/core/types/delivery-shipment-costs.types'

const deliveryShipmentCostsRepository = new DeliveryShipmentCostsRepository()

export class DeliveryShipmentCostsService {
    async getShipmentCosts(
        params: GetDeliveryShipmentCostsParams
    ): Promise<GetDeliveryShipmentCostsResponse> {
        const response = await deliveryShipmentCostsRepository.getShipmentCosts(params)
        return response.data
    }

    async getStandardParams(
        params: GetDeliveryStandardParamsParams
    ): Promise<GetDeliveryStandardParamsResponse> {
        const response = await deliveryShipmentCostsRepository.getStandardParams(params)
        return response.data
    }

    async createIndividualShipmentCost(
        payload: DeliveryIndividualShipmentCostPayload
    ): Promise<void> {
        const response = await deliveryShipmentCostsRepository.createIndividualShipmentCost(payload)
        return response.data
    }

    async createIndividualStandardParams(
        payload: DeliveryIndividualStandardParamsPayload
    ): Promise<void> {
        const response = await deliveryShipmentCostsRepository.createIndividualStandardParams(
            payload
        )
        return response.data
    }

    async updateIndividualShipmentCost(
        payload: DeliveryIndividualShipmentCostPayload
    ): Promise<void> {
        const response = await deliveryShipmentCostsRepository.updateIndividualShipmentCost(payload)
        return response.data
    }

    async updateIndividualStandardParams(
        payload: DeliveryIndividualStandardParamsPayload
    ): Promise<void> {
        const response = await deliveryShipmentCostsRepository.updateIndividualStandardParams(
            payload
        )
        return response.data
    }
}
